import Link from '@mui/material/Link';
import React, { type FC } from 'react';

interface LinkProps {
  id: string;
  children?: React.ReactNode;
  color?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | 'textPrimary'
    | 'textSecondary'
    | 'textDisabled'
    | 'inherit';
  variant?:
    | 'body1'
    | 'body2'
    | 'body3'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'caption';
  align?: 'center' | 'inherit' | 'justify' | 'left' | 'right';
  fontStyle?: 'italic' | 'normal' | 'oblique';
  fontWeight?: 'normal' | 'bold';
  className?: string;
  underline?: 'always' | 'hover' | 'none';
  href?: string;
  target?: '_blank' | '_self' | '_parent' | '_top';
  rel?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  disabled?: boolean;
}

const CustomLink: FC<LinkProps> = ({
  id,
  children,
  color = 'textPrimary',
  variant = 'body1',
  align = 'inherit',
  className,
  underline = 'always',
  fontStyle = 'normal',
  fontWeight = 'normal',
  href,
  target,
  rel,
  onClick,
  disabled = false,
  ...rest
}) => {
  return (
    <Link
      id={id}
      color={disabled ? 'textDisabled' : color}
      variant={variant}
      align={align}
      className={className}
      underline={disabled ? 'none' : underline}
      href={disabled ? undefined : href}
      target={disabled ? undefined : target}
      rel={disabled ? undefined : rel}
      onClick={disabled ? undefined : onClick}
      sx={{
        fontStyle: { fontStyle },
        fontWeight: { fontWeight },
        textDecoration:
          underline === 'always' ? 'underline !important' : 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        pointerEvents: disabled ? 'none' : 'auto',
        opacity: disabled ? 0.6 : 1,
      }}
      {...rest}
    >
      {children}
    </Link>
  );
};

export default CustomLink;
